export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";